import Main from "_c/main"

export default {
    path: "/",
    name: "",
    component:Main,
    children:[
        {
            path:"/home",
            name:"home",
            component: () => import('@/view/home'),
            meta:{
                parent:true,
                name:"首页",
                assess:false
            },
        }
    ]
    
}


// WEBPACK FOOTER //
// ./src/router/modules/Home.js